import MicroModal from "micromodal";
import Cookies from 'js-cookie';

MicroModal.init();

const openingDaysModal = document.getElementById('openingDaysModal');
if (Cookies.get('popup') === undefined && openingDaysModal) {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
            MicroModal.show('openingDaysModal', {
                awaitCloseAnimation: true,
            });
        }, 500);
    });
    document.getElementById('closeOpeningDaysModal').addEventListener('click', () => {
        Cookies.set('popup', true, { expires: 1 });
    });
}